// @core/api/endpoints/affiliate/track_click.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  TrackClickResponse,
} from '../../../types/affiliate';

const BASE_PATH = '/affiliate';

/**
 * Track click and redirect
 * Tracks a click event and returns redirect URL. Called when user clicks an affiliate link.
 * @public This endpoint does not require authentication
 */
export async function TrackClick(
  tracking_code: string,
  params?: {
    sub1?: string | number | boolean;
    sub2?: string | number | boolean;
    sub3?: string | number | boolean;
    sub4?: string | number | boolean;
    sub5?: string | number | boolean;
  },
  options?: RequestOptions
): Promise<TrackClickResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/track/click/:tracking_code`;
  requestPath = requestPath.replace(':tracking_code', encodeURIComponent(tracking_code));
  const requestOptions = { ...options, skipAuth: true };
  return client.get<TrackClickResponse>(requestPath, { ...requestOptions, params });
}
